module.exports = __webpack_public_path__ + "img/tibet.4400f8bf.png";